var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","small":"","loading":_vm.loading,"color":"error"},on:{"click":function($event){$event.stopPropagation();return _vm.remove(_vm.item)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }